import React, { forwardRef } from 'react';

export default function SelfGradeOption ({ optionName, value, disabled }) {
    return (
        <option key={value} value={value} disabled={disabled}>{optionName}</option>
    )
}
